<template>
  <div class="bg-white rounded-3xl p-4 shadow-sm">
    <div v-if="title" class="mb-3 flex items-start justify-between">
      <div>
        <h3 class="text-base font-semibold text-primary-dark-text">
          {{ title }}
        </h3>
        <p v-if="subtitle" class="text-xs text-neutral-light mt-1">
          {{ subtitle }}
        </p>
      </div>
      <slot name="actions"></slot>
    </div>

    <template v-if="hasData">
      <div class="space-y-3">
        <div v-for="(item, index) in items" :key="item.label" class="space-y-1">
          <div class="flex items-center justify-between text-xs font-medium">
            <span class="text-gray-600">{{ item.label }}</span>
            <span class="text-gray-500">
              {{ percentageLabel(item.value, index === items.length - 1) }}
            </span>
          </div>
          <div class="relative h-3 rounded-full bg-gray-200">
            <span
              class="absolute top-0 left-0 h-full rounded-full"
              :style="barStyle(item)"
            ></span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="flex flex-col items-center justify-center gap-1.5 py-6 text-center text-xs text-neutral-light"
      >
        <svg
          class="h-8 w-8 text-neutral-light/60"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M12 3v10" />
          <path d="M6 11v6" />
          <path d="M18 7v10" />
          <rect x="3" y="19" width="18" height="2" rx="1" />
        </svg>
        <p class="font-medium text-primary-dark-text">No vote data yet</p>
        <p>Vote statistics will appear once team members start responding.</p>
      </div>
    </template>
  </div>
</template>

<script setup>
/* global defineProps */
import { computed } from "vue";

// eslint-disable-next-line no-undef
const props = defineProps({
  title: {
    type: String,
    default: "",
  },
  subtitle: {
    type: String,
    default: "",
  },
  items: {
    type: Array,
    required: true,
    validator: (value) =>
      value.every((item) =>
        ["label", "value", "color", "accent"].every((key) =>
          Object.prototype.hasOwnProperty.call(item, key)
        )
      ),
  },
  suffix: {
    type: String,
    default: "%",
  },
});

const hasData = computed(
  () => Array.isArray(props.items) && props.items.length > 0
);

const filledPercentage = (value) => Math.max(0, Math.min(100, value));

const barStyle = (item) => ({
  width: `${filledPercentage(item.value)}%`,
  background: item.gradient || item.color,
  borderRadius: "9999px",
  boxShadow: item.accent ? `0 0 0 6px rgba(255,255,255,0)` : undefined,
});

const percentageLabel = (value, isLastItem) =>
  isLastItem && props.suffix === "%"
    ? "Complete"
    : `${filledPercentage(value)}${props.suffix}`;
</script>
